export default "__VITE_ASSET__B$e$WPRK__"